/**
 * Created by wajidafaneh on 03/08/2016.
 */
(function (angular, MemberAPI) {

    angular
        .module('harriApp')
        .controller('ScheduleDemoModalController', ["$scope", "modalData", "onScheduleDemoSuccess", function ($scope, modalData, onScheduleDemoSuccess) {

            var serviceCode;
            switch (modalData.feature) {
                case 'TEAM_LIVE':
                    serviceCode = 'TEAM_SCHEDULING';
                    break;
                case 'LMS':
                    serviceCode = 'LMS';
                    break;
                default:
                    serviceCode = 'ON_BOARDING';
                    break
            }

            $scope.isRequesting = false;
            $scope.isLoading = false;
            $scope.canRequestDemo = false;

            var loadRequestDemo = function() {
                $scope.isLoading = true;
                MemberAPI.getDemoRequest(modalData.brand.id, serviceCode)
                    .then(function(res) {
                        $scope.isLoading = false;
                        $scope.canRequestDemo = !res.demo_requested;

                        setTimeout(function() {
                            $scope.$digest();
                        }, 1);
                    }, function (err) {
                        console.error("can't load request demo data", err);
                    });
            };

            $scope.hideModal = function () {
                $scope.$hide();
            };

            $scope.scheduleDemo = function () {
                $scope.isRequesting = true;

                MemberAPI.updateDemoRequest(modalData.brand.id, serviceCode)
                    .then(function (res) {
                        onScheduleDemoSuccess(angular.copy(modalData));
                        $scope.hideModal();

                        setTimeout(function() {
                            $scope.$digest();
                        }, 1);
                    }, function (err) {
                        if (err.status === 400) {
                            onSchduleDemoFail(angular.copy(modalData));
                            $scope.hideModal();
                            $scope.$digest();
                        } else {
                            console.error('err: ', err);
                        }
                    });
            };

            var init = function () {
                loadRequestDemo();
            };

            init();
        }]);
})
(angular, MemberAPI);
